/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RewardMetadataTypeBundle {
    TEXT = 'Text',
    NUMBER = 'Number',
    DATE = 'Date',
    SELECT = 'Select',
}
